import App from './App.vue'
import {createI18nInstance} from "@/i18n.js";
import {ViteSSG} from 'vite-ssg'
import {routes} from './router'
import {
    Auth,
    ChatWidget,
    KtCallback,
    SiteFooter,
    MobileDownload,
    RelocationBanner,
    AppHeader,
    BaseModal,
    PayWidget,
    Dialog, installI18nMessages
} from "@ismet/vue-ui-kit";
import {vuetify} from "@/vuetify.ts";
import {createPinia} from "pinia";
import '@ismet/vue-ui-kit/dist/vue-ui-kit.css'
import './assets/scss/main.scss'
import { api } from '@/request'
import Cookies from 'js-cookie'
import * as Sentry from "@sentry/vue";
import {domainForCookie} from "@/utills/domain.util.ts";

if (typeof window === 'undefined') {
    global.__VUE_PROD_DEVTOOLS__ = false;
}
const isClient = typeof window !== 'undefined'

const ALLOWED_LANGS = ['kk', 'ru', 'en'];

export const createApp = ViteSSG(App, {routes, base: '/'}, ({app, router}) => {
    const initialLocale = isClient ? (Cookies.get('lang') || 'kk') : 'kk';
    const i18n = createI18nInstance(initialLocale)
    app.use(createPinia())
    installI18nMessages(i18n)
    app.use(i18n)
    app.use(vuetify)
    app.provide("api", api)
    app.component('Auth', Auth)
    app.component('KtCallback', KtCallback)
    app.component('ChatWidget', ChatWidget)
    app.component('SiteFooter', SiteFooter)
    app.component('SiteHeader', AppHeader)
    app.component('BaseModal', BaseModal)
    app.component('PayWidget', PayWidget)
    app.component('MobileDownload', MobileDownload)
    app.component('RelocationBanner', RelocationBanner)
    app.component('Dialog', Dialog)

    if (import.meta.env.MODE === 'production') {
        Sentry.init({
            app,
            dsn: "https://1cd8bac1b264958a5c6e3359d490e587@sentry.telecom.kz/125",
        });
    }

    router.beforeEach((to, from, next) => {
        if (!isClient) {
            return next();
        }

        const queryLang = to.query.lang;
        const cookieLang = Cookies.get('lang');

        // 1. Приоритет №1: Если явно ввели /kk в URL -> сбрасываем на kk
        if (to.path === '/kk') {
            changeCookie('kk');
            return next({ name: 'kk', query: to.query, replace: true });
        }

        // 2. Приоритет №2: query-параметр ?lang=
        if (queryLang && ALLOWED_LANGS.includes(queryLang)) {
            const query = { ...to.query };
            delete query.lang;

            changeCookie(queryLang);
            if (to.name !== queryLang) {
                return next({ name: queryLang, query, replace: true });
            } else {
                return next({ path: to.path, query, replace: true });
            }
        }

        // 3. Приоритет №3: Зашли на главный адрес '/' без параметров
        if (to.path === '/') {
            if (cookieLang && cookieLang !== 'kk' && ALLOWED_LANGS.includes(cookieLang)) {
                return next({ name: cookieLang, query: to.query, replace: true });
            }
        }

        // 4. Установка локали для текущего маршрута
        const targetLocale = to.meta.locale || 'kk';

        if (i18n.mode === 'legacy') {
            i18n.global.locale = targetLocale;
        } else {
            i18n.global.locale.value = targetLocale;
        }

        changeCookie(targetLocale);

        next();
    });
})


const changeCookie = (l) => {
    const result = new Date();
    result.setDate(result.getDate() + 400);
    Cookies.set('lang', l, {
        expires: result,
        path: '/',
        domain: domainForCookie()
    });
}
